import * as React from 'react';
import { SIZES, ICON, OPACITY, FONT_SIZE } from 'constants/components';
import { NAVIGATION_ITEM_ICON_NAMES } from 'constants/common';
import { isAttempted } from 'utils/questions';
import QuestionTreeNode, { QuestionTreeNodeProps } from './QuestionTreeNode';
import { QuestionItem, TitleText, QuestionIcon } from './QuestionTreeNode.styled';

interface QuestionTreeNodeSubmitOnceProps extends QuestionTreeNodeProps {
  isAttemptSubmitted?: boolean;
  hasGuidedReattempt: boolean;
}

export default class QuestionTreeNodeSubmitOnce extends QuestionTreeNode<
  QuestionTreeNodeSubmitOnceProps
> {
  getIconName = (
    isAttemptSubmitted: boolean,
    isAnsweredCorrectly: boolean,
    isSurvey: boolean,
    isAnswered: boolean,
    hasGuidedReattempt: boolean,
    isPreviousAnswerCorrect: boolean,
    isAnswerChanged: boolean
  ) => {
    let questionIconText = '';

    const whenNotSubmitted = () => {
      if (hasGuidedReattempt) {
        if (isAttempted(this.props.question)) {
          return NAVIGATION_ITEM_ICON_NAMES.OK;
        }
        return NAVIGATION_ITEM_ICON_NAMES.QUESTION;
      }
      return NAVIGATION_ITEM_ICON_NAMES.OK;
    };

    const whenSubmitted = () => {
      if (isAnsweredCorrectly) {
        return NAVIGATION_ITEM_ICON_NAMES.OK;
      }
      return NAVIGATION_ITEM_ICON_NAMES.CLOSE;
    };

    if (isSurvey) {
      questionIconText = 'survey';
    } else if (!isAttemptSubmitted && isAttempted(this.props.question)) {
      questionIconText = whenNotSubmitted();
    } else if (isAttemptSubmitted && isAnswered) {
      questionIconText = whenSubmitted();
    } else {
      questionIconText = 'question';
    }
    return questionIconText;
  };

  getShapeColor = (
    isAttemptSubmitted: boolean,
    isAnsweredCorrectly: boolean,
    isSurvey: boolean,
    hasGuidedReattempt: boolean,
    isPreviousAnswerCorrect: boolean
  ) => {
    let questionTextColor = 'textColor';
    if (isAttemptSubmitted) {
      if (isAnsweredCorrectly || isSurvey) {
        questionTextColor = 'correctColor';
      } else {
        questionTextColor = 'incorrectColor';
      }
    } else if (!isAttemptSubmitted && hasGuidedReattempt && isPreviousAnswerCorrect) {
      questionTextColor = 'correctColor';
    }
    return questionTextColor;
  };

  renderQuestionIcon = (
    isAnswered: boolean,
    isAnsweredCorrectly: boolean,
    isSurvey: boolean,
    isAttemptSubmitted = false,
    hasGuidedReattempt: boolean,
    isPreviousAnswerCorrect: boolean,
    isAnswerChanged: boolean
  ) => {
    const questionIconText = this.getIconName(
      isAttemptSubmitted,
      isAnsweredCorrectly,
      isSurvey,
      isAnswered,
      hasGuidedReattempt,
      isPreviousAnswerCorrect,
      isAnswerChanged
    );
    const questionTextColor = this.getShapeColor(
      isAttemptSubmitted,
      isAnsweredCorrectly,
      isSurvey,
      hasGuidedReattempt,
      isPreviousAnswerCorrect
    );

    return (
      <QuestionIcon
        name={questionIconText}
        size={SIZES.SMALL}
        shape={ICON.SHAPES.ROUND_FULL_COLOR}
        shapeColor={questionTextColor}
        iconColor={!isAttemptSubmitted && questionTextColor}
        shapeOpacity={!isAttemptSubmitted && OPACITY.PERCENT_8}
        {...(!isAnswered && { fontSize: FONT_SIZE.SEVEN })}
      />
    );
  };

  render() {
    const {
      question,
      onClick,
      isActive,
      onKeyDown,
      role,
      tabIndex,
      isAttemptSubmitted = false,
      hasGuidedReattempt
    } = this.props;
    const {
      title,
      isInformationContent,
      isAnswered,
      isAnsweredCorrectly,
      isSurvey,
      isPreviousAnswerCorrect,
      isAnswerChanged
    } = question;

    const isPassed = isAttempted(question);
    return (
      <QuestionItem
        isActive={isActive}
        isPassed={isPassed}
        tabIndex={tabIndex}
        role={role}
        ariaLabel={
          !isInformationContent
            ? this.getTitleQuestion(isAnswered, isAnsweredCorrectly, title)
            : title
        }
        {...(!isActive && { onClick, onKeyDown })}
      >
        {!isInformationContent &&
          this.renderQuestionIcon(
            isAnswered,
            isAnsweredCorrectly,
            isSurvey,
            isAttemptSubmitted,
            hasGuidedReattempt,
            isPreviousAnswerCorrect,
            isAnswerChanged
          )}
        <TitleText>{title}</TitleText>
      </QuestionItem>
    );
  }
}
